export enum DeviceType {
    DESKTOP = 'desktop',
    MOBILE = 'mobile',
    TABLET = 'tablet',
};

export const getDeviceType = (windowObj: Window): DeviceType => {
    if (windowObj.innerWidth >= 1025) {
        return DeviceType.DESKTOP;
    }
    if (windowObj.innerWidth >= 768) {
        return DeviceType.TABLET;
    }
    return DeviceType.MOBILE;
};
